(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('newVersionSvc', newVersionSvc)

  function newVersionSvc($window, $rootScope) {
    var svc = this
    svc.available = false
    svc.prompt = prompt
    svc.setAvailable = setAvailable
  
    ///////////
  
    function prompt() {
      iziToast.show({
        id:"newversion",
        timeout:false,
        animateInside: true,
        drag:false,
        layout:2,
        close:false,
        zindex: 2147483646,
        title: "New version of the app available",
        message: "It is recommended that you refresh now, any unsaved data will be lost.",
        icon: 'fas fa-info-circle fa-fw animated slow',
        progressBar: false,
        position: 'bottomCenter',
        transitionIn: 'fadeInUp',
        ransitionOut: 'fadeOutDown',
        ransitionInMobile: 'fadeIn',
        ransitionOutMobile: 'fadeOut',
        backgroundColor: '#222d32',
        theme:'dark',
        displayMode: 2,
        buttons:[
          ['<button class="btn">Refresh Now</button>', function(instance, toast){
            $window.location.reload(true)
          }],
          ['<button class="btn">Dismiss</button', function(instance, toast){
            instance.hide({}, toast, 'newversion')
          }]
        ]
      })
    }

    function setAvailable() {
      if(!svc.available){
        prompt()
        svc.available = true
        $rootScope.$apply() // we must call apply as the scope will not be aware of changes in the service (without this the new version available button will not immediately appear in the nav bar)
      }
    }
  }
})()
